
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "LargeHeading",
  props: {
    title: String,
    headingLevel: {
      type: Number as PropType<1 | 2 | 3 | 4 | 5 | 6>,
      default: 1,
    },
  },
});
